import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { css } from 'styled-components';
import { Alert } from '../../alert/index.js';
import darken from 'polished/lib/color/darken';
import { FIELDSET_VARIANTS } from './constants.js';
export { FIELDSET_VARIANTS } from './constants.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ALERT_VARIANTS } from '../../alert/constants.js';

var _templateObject, _templateObject2;
const fieldsetIndentedStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-inline-start: ", ";\n  border-inline-start: ", ";\n\n  ", " {\n    padding-inline-start: ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.baseSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return "1px solid ".concat(darken(0.1, theme.colors.accents.muted));
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.mediaQueries.sm;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing.doubleSpacing;
});
const StyledFieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "fieldset__StyledFieldset",
  componentId: "sc-dkqfh8-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin: 0;\n  padding: 0;\n  border: 0;\n\n  ", ";\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing.baseSpacing;
}, _ref6 => {
  let {
    variant
  } = _ref6;
  return variant === FIELDSET_VARIANTS.INDENTED && fieldsetIndentedStyles;
});
const Fieldset = _ref7 => {
  let {
    error,
    children,
    ...rest
  } = _ref7;
  return /*#__PURE__*/jsxs(StyledFieldset, {
    ...rest,
    children: [children, error && /*#__PURE__*/jsx(Alert, {
      variant: ALERT_VARIANTS.ERROR,
      children: error
    })]
  });
};

export { Fieldset };
